
const Download = () => {
  const u = navigator.userAgent;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  let theHref = '';
  if (isIOS) { //这里写IOS操作

    theHref = 'https://apps.apple.com/cn/app/id1555421939';

  } else {  //非ios
    theHref = 'http://download.gyyx.cn/Default.ashx?typeid=1068&netType=1';
  }
  window.location.href = theHref;
  return <></>;
};
export default Download;
